<template>
  <div class="home">
    <!-- 锚点菜单 start -->
    <scroll-menu @scrollInto="scrollInto" v-if="styleList.length" :styleList="styleList"></scroll-menu>
    <!-- 锚点菜单 end -->

    <!-- 轮播图 start -->
    <div class="banner">
      <el-carousel class="carousel" height="545px" :autoplay="true">
        <el-carousel-item :style="{ backgroundImage: 'url( ' + item.themeFileUrl + ')',cursor:item.adLinkUrl?'pointer':'default' }" v-for="(item, index) in dataBannerList" :key="index" @click.native="themeLink(item.adLinkUrl)">
          <img class="img_item" :style="{cursor:item.themeContentItem.adLinkUrl?'pointer':'default'}" v-if="item.adPhotoFileUrl" :src="item.adPhotoFileUrl" @click.stop="themeContentLink(item.themeContentItem)" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 轮播图 end -->

    <div class="header container1" ref="header">
      <!-- 人气推荐 -->
      <div class="header_left">
        <div class="small_house more_link">
          <span>{{tagSerNoData.name4}}</span>
          <span class="com_link" @click="navigateTo(tagSerNoData.serNo4)">更多推荐>></span>
        </div>
        <router-link class="item goods_item" v-for="(v,i) in recommeList" :key="i" :to="{path:'/goodsDetails/'+v.serNo+'.html'}" target="_blank">
          <div class="img mask">
            <img v-lazy="v.mainPreviewImageFilePath">
          </div>
          <p class="goods_name com_link">{{v.goodsName}}</p>
          <div class="sprice com_link" style="padding:0px 0px 0px;">
            市场参考价：
            <span class="line_th">￥{{ v.salePrice | priceValue }}</span>
          </div>
          <div class="price">
            <p class="cprice" v-if="$cookies.isKey('ACCESS_TOKEN')">￥{{ v.clientSalePrice | priceValue}}</p>
            <p class="cprice cur_pointer" v-else style="font-size:14px;" @click.prevent.stop="$refs.diaLogin.elVisible = true;">登录查看多比价</p>
          </div>
        </router-link>
      </div>
      <!-- 热卖排行榜 -->
      <div class="header_right">
        <div class="item mask" @click="themeContentLink(topSellersData.themeContentItem)">
          <div class="img_box" v-for="(v,i) in topSellersData.imgList" :key="i">
            <img v-lazy="v">
          </div>
          <div class="title">热卖排行榜</div>
          <div class="all btn_hover" @click.stop="navigateTo(tagSerNoData.serNo1)">全部</div>
        </div>
        <div class="item mask" @click="themeContentLink(goodsNowData.themeContentItem)">
          <div class="img_box" v-for="(v,i) in goodsNowData.imgList" :key="i">
            <img v-lazy="v">
          </div>
          <div class="title">网红特卖</div>
          <div class="all btn_hover" @click.stop="navigateTo(tagSerNoData.serNo2)">全部</div>
        </div>
      </div>
    </div>

    <!-- 多比优选 start -->
    <div class="duobi container1" ref="duobi">
      <h2 class="come_title more_link">
        <p>{{tagSerNoData.name5}}</p>
        <ul class="tab">
          <li :class="{'item':true,'active':v.serNo==currentSpaceSerNo}" v-for="(v,i) in spaceSerNoList" :key="i" @click="onChangeSpaceSerNo(v.serNo)">
            {{v.name}}
          </li>
        </ul>
        <span class="com_link" @click="navigateTo(tagSerNoData.serNo5)">更多优选>></span>
      </h2>
      <div class="content">
        <router-link class="goods_item" v-for="(v,i) in duobiPreferredList" :key="i" :to="{path:'/goodsDetails/'+v.serNo+'.html'}" target="_blank">
          <div class="img mask">
            <img v-lazy="v.mainPreviewImageFilePath">
          </div>
          <p class="goods_name com_link">{{v.goodsName}}</p>
          <div class="sprice com_link" style="padding:0px 0px 0px;">
            市场参考价：
            <span class="line_th">￥{{ v.salePrice | priceValue }}</span>
          </div>
          <div class="price">
            <p class="cprice" v-if="$cookies.isKey('ACCESS_TOKEN')">￥{{ v.clientSalePrice | priceValue}}</p>
            <p class="cprice cur_pointer" v-else style="font-size:14px;" @click.prevent.stop="$refs.diaLogin.elVisible = true;">登录查看多比价</p>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 多比优选 end -->

    <!-- 热销套系 start -->
    <div class="hotsale container1" ref="hotsale">
      <h2 class="come_title more_link">
        <span>热销套系</span>
        <router-link to="/wholeBag" target="_blank">更多套系>></router-link>
      </h2>
      <div class="content">
        <router-link class="item mask" :to="{path:'/wholeBag/wholeBagDetail',query:{themeNo:item.themeNo}}" v-for="(item,index) in hotsaleList" :key="index" target="_blank">
          <div class="img">
            <img v-lazy="item.mainPreviewImageFilePath">
          </div>
          <p class="title"><span>{{item.name}}</span></p>
          <p class="sub_title price"><span>￥{{item.totalPrice | priceValue}}</span></p>
          <div class="other_list">
            <div class="list_item" v-for="(v,i) in item.previewImage" :key="i">
              <div class="img">
                <img v-lazy="v.filePath">
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 热销套系 end -->

    <!-- 各种风格 start -->
    <div class="style_item" :ref="'style'+styleI" v-for="(styleObj,styleI) in styleList" :key="styleI">
      <div class="container1">
        <h2 class="come_title">{{styleObj.title}}</h2>
        <el-carousel class="theme1" :interval="3000" type="card" height="350px" indicator-position='none'>
          <el-carousel-item v-for="(v,i) in styleObj.type3" :key="i" @click.native="themeContentLink(v)">
            <img class="img_box" v-lazy="v.adPhotoFileUrl">
            <div class="brand_box">
              <p class="brand_name">{{v.brandInfo.name}}</p>
              <p>{{v.title}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="theme2">
          <h4 class="title more_link">
            <span>{{styleObj.title}}商品推荐</span>
            <span class="com_link" @click="themeLink(styleObj.adLinkUrl)">更多商品>></span>
          </h4>
          <div class="flex">
            <div class="goods_item" v-for="(v,i) in styleObj.type1" :key="i" @click="themeContentLink(v)">
              <div class="img mask">
                <img v-lazy="v.adPhotoFileUrl">
              </div>
              <p class="goods_name com_link">{{v.goodsMixInfo.mixName}}</p>
              <div class="sprice com_link" style="padding:0px 0px 0px;">
                市场参考价：
                <span class="line_th">￥{{ v.goodsMixInfo.salePrice | priceValue }}</span>
              </div>
              <div class="price">
                <p class="cprice" v-if="$cookies.isKey('ACCESS_TOKEN')">￥{{ v.goodsMixInfo.clientSalePrice | priceValue}}</p>
                <p class="cprice cur_pointer" v-else style="font-size:14px;" @click.prevent.stop="$refs.diaLogin.elVisible = true;">登录查看多比价</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 各种风格 end -->
    <dialog-login ref="diaLogin" @updateLogin="updateLogin"></dialog-login>
  </div>
</template>

<script>
import DialogLogin from "@/pages/page1/components/dialogLogin.vue";
import {
  GetAdPositionId,
  GetAdPosAndType,
  GetHotWholeList,
  GetTagGoodsList,
  GetNameBySerNo,
} from "@/pages/page1/api/modules/home";
import ScrollMenu from "@/pages/page1/components/scrollMenu";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  metaInfo: {
    title: "多比官网 网上家具商城 在线销售家具、家饰等 一站式家居购物网站平台",
    meta: [
      {
        name: "keyWords",
        content: "多比官网,多比网,多比利家,家具,家具网",
      },
      {
        name: "description",
        content:
          "多比利家（www.duobihouse.com）家具商城，整合优质供应链资源，" +
          "提供优质家具渠道货源；协作转业服务商团队，提供送装售后无忧服务；" +
          "质量保证、物美价廉，为装饰行业赋正能量；一站式购买、服务到家，让消费者买得放心，住得舒心！",
      },
    ],
  },
  components: {
    Swiper,
    SwiperSlide,
    ScrollMenu,
    DialogLogin,
  },
  data() {
    return {
      dataBannerList: [], //轮播
      recommeList: [], //人气推荐
      topSellersData: { imgList: [], themeContentItem: {} }, //热卖排行
      goodsNowData: { imgList: [], themeContentItem: {} }, //现货特卖
      duobiPreferredList: [], //多比优选
      hotsaleList: [], //热销套系
      styleList: [], //风格楼层
      spaceSerNoList: [
        { name: "客厅", serNo: 7 },
        { name: "卧室", serNo: 1 },
        { name: "餐厅", serNo: 3 },
        { name: "青少年", serNo: 4 },
      ], //空间列表
      currentSpaceSerNo: 7, //当前空间
      tagSerNoData: {},
    };
  },
  mounted() {
    let adPositionId = this.$configId.adPositionId;
    // 推广商品 = 1,宣传活动 = 2,推广品牌 = 3
    this.getHomeTopList(adPositionId.homeTopAd);
    this.getTopSellers(adPositionId.topSellers, this.topSellersData);
    this.getTopSellers(adPositionId.goodsNow, this.goodsNowData);
    this.getStyleList(adPositionId.styleFloor);
    this.getHotsaleList();
    // 获取所有标识（正序）
    GetNameBySerNo({ tagSerNo: null }).then((res) => {
      res.data.forEach((v, i) => {
        this.tagSerNoData["serNo" + (i + 1)] = v.serNo;
        this.tagSerNoData["name" + (i + 1)] = v.name;
      });
      this.getRecommeList();
      this.getDuoBiList();
    });
  },
  methods: {
    scrollInto(ref) {
      // console.log(this.$refs[ref]);
      let element;
      // 循环出来的在数组
      if (this.$refs[ref][0]) {
        element = this.$refs[ref][0];
      } else {
        element = this.$refs[ref];
      }
      // ie 不支持scrollTo的对象写法
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        window.scrollTo(0, element.offsetTop);
        return;
      }
      // edge 不支持scrollTo的对象写法
      if (navigator.userAgent.indexOf("Edge") > -1) {
        window.scrollTo(0, element.offsetTop);
        return;
      }
      // 其他浏览器
      window.scrollTo({ behavior: "smooth", top: element.offsetTop });
      //传参方式两种 布尔或者对象 ie不支持对象（暂不考虑）
      // element.scrollIntoView({
      //   behavior: "smooth", // 平滑滚动
      // });
    },
    // 广告位 轮播
    getHomeTopList(id) {
      let params = {
        adPositionId: id,
        themeCount: 6,
        contentCount: 1,
        loadNoConTheme: 1, //不过滤没有内容的主题
        openRandom: 0, //不随机
      };
      GetAdPositionId(params).then((res) => {
        // console.log("获取首屏轮播广告位内容", res.data);
        res.data = this.setInfoObj(res.data);
        this.dataBannerList = res.data;
        this.dataBannerList.forEach((v) => {
          try {
            v.themeContentItem = v.themeContentList[0];
            v.adPhotoFileUrl = v.themeContentList[0].adPhotoFileUrl;
          } catch (error) {}
        });
      });
    },
    // 广告位 热卖排行（随机）
    getTopSellers(id, vData) {
      let params = { adPositionId: id, themeCount: 1, contentCount: 1 };
      GetAdPositionId(params).then((res) => {
        // console.log("热卖排行", res);
        res.data = this.setInfoObj(res.data);
        if (res.data.length > 0) {
          Object.assign(vData, res.data[0]);
          if (vData.themeContentList.length > 0) {
            vData.imgList.push(vData.themeContentList[0].adPhotoFileUrl || "");
            vData.themeContentItem = vData.themeContentList[0];
          } else {
            vData.imgList.push("");
          }
        } else {
          vData.imgList.push("");
        }
      });
    },
    // 广告位 风格楼层
    getStyleList(id) {
      let params = {
        adPositionId: id,
        themeCount: 6,
        contentCount: 26,
        openRandom: 0, //不随机
      };
      GetAdPositionId(params).then((res) => {
        // console.log("风格楼层", res);
        let resData = this.setInfoObj(res.data);
        resData.forEach((item) => {
          item.type1 = item.themeContentList.filter((v) => v.themeConType == 1); //推广商品
          item.type1 = item.type1.filter((v, i) => i < 4); //前四项
          item.type3 = item.themeContentList.filter((v) => v.themeConType == 3); //品牌
        });
        this.styleList = resData;
      });
    },
    // 标识 人气推荐
    getRecommeList() {
      let params = { tagSerNo: this.tagSerNoData.serNo4, num: 4, sortType: 0 };
      GetTagGoodsList(params).then((res) => {
        // console.log("人气推荐", res);
        this.recommeList = res.data;
      });
    },
    // 标识 多比优选
    getDuoBiList() {
      let params = {
        tagSerNo: this.tagSerNoData.serNo5,
        num: 4,
        sortType: 0, //0升序  1随机
        spaceSerNo: this.currentSpaceSerNo,
      };
      GetTagGoodsList(params).then((res) => {
        // console.log("多比优选", res);
        this.duobiPreferredList = res.data;
      });
    },
    // 获取热销套系
    getHotsaleList() {
      let params1 = {
        num: 3, //返回数量
        wholeType: 0, //家具拎包0 电器套餐1
      };
      GetHotWholeList(params1).then((res) => {
        // console.log("获取热销套系列表", res);
        this.hotsaleList = res.data;
        this.hotsaleList.forEach((item) => {
          item.previewImage = this.ActionRandomDataList(item.previewImage, 3);
        });
      });
    },

    // 多比优选 空间切换
    onChangeSpaceSerNo(serNo) {
      this.currentSpaceSerNo = serNo;
      this.getDuoBiList();
    },
    // 推广商品或品牌 兼容goodsMixInfo和brandInfo为null
    setInfoObj(arr) {
      arr.forEach((item) => {
        item.themeContentList.forEach((v) => {
          if (!v.goodsMixInfo) {
            v.goodsMixInfo = {};
          }
          if (!v.brandInfo) {
            v.brandInfo = {};
          }
        });
      });
      return arr;
    },
    // 数据随机筛选
    ActionRandomDataList(oldArray, num) {
      if (oldArray.length === 0) return [];
      let resArray = [];
      let newArray = [].concat(oldArray); //拷贝原数组进行操作就不会破坏原数组
      let forNumber = num - oldArray.length > 0 ? oldArray.length : num; //防止原数组长度小于要筛选出的数量
      for (let index = 0; index < forNumber; index++) {
        // 随机获取一个0-1之间的小数, 然后乘以自身长度，得到一个大于等于0,小于自身长度的一个数. 则获取的一个随机数就为[0-自身长度之间]的一个数
        let i = Math.floor(Math.random() * newArray.length);
        resArray.push(newArray[i]);
        newArray.splice(i, 1); //删掉，然后在下轮循环中就可以避免重复获取
      }
      return resArray;
    },
    // 主题位置跳转
    themeLink(url) {
      if (!url) {
        return false;
      }
      if (url.indexOf("http") == -1) {
        url = "http://" + url;
      }
      window.open(url, "_blank");
    },
    // 主题内容跳转
    themeContentLink(v) {
      // themeConType为2  且adLinkUrl有值
      if (v.adLinkUrl) {
        if (v.adLinkUrl.indexOf("http") == -1) {
          v.adLinkUrl = "http://" + v.adLinkUrl;
        }
        window.open(v.adLinkUrl, "_blank");
        return;
      }
      // 推广商品
      if (v.themeConType == 1) {
        let newUrl = this.$router.resolve({
          name: "goodsDetails",
          params: { mixSerNo: v.goodsMixSerNo + ".html" },
        });
        window.open(newUrl.href, "_blank");
      }
      // 推广品牌
      if (v.themeConType == 3) {
        let newUrl = this.$router.resolve({
          path: "/category",
          query: { brandSerNos: v.brandInfo.serNo },
        });
        window.open(newUrl.href, "_blank");
      }
    },
    // 标识跳转
    navigateTo(tagSerNo) {
      let newUrl = this.$router.resolve({
        path: "/hotSaleTop",
        query: { tagSerNo },
      });
      window.open(newUrl.href, "_blank");
    },
    // 登录操作
    updateLogin(isLogin) {
      // console.log(isLogin);
      if (isLogin) {
        location.reload();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  color: #333333;
  background-color: #f1f1f1;
  .banner {
    height: 545px;
    width: 100%;
    min-width: @themeWidth;
    box-shadow: 0px 2px 10px #cccccc;
    /deep/ .carousel {
      height: 100% !important;
      .el-carousel__container {
        height: 100% !important;
        .el-carousel__item {
          text-align: center;
          background-repeat: no-repeat;
          background-size: cover;
          filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod='scale');
          // -moz-background-size: 100% 100%;
          // background-size: 100%;
          background-position: center;
          .img_item {
            width: auto;
            max-width: 746px;
            height: 100%;
          }
        }
      }
      .el-carousel__indicators {
        .el-carousel__indicator {
          .el-carousel__button {
            width: 29px;
            height: 7px;
            background: #cccccc;
            opacity: 0.5;
            border-radius: 3px;
          }
        }
        .is-active {
          .el-carousel__button {
            background: rgba(255, 170, 32, 1);
          }
        }
      }
    }
  }
  .header {
    padding-top: 32px;
    height: 336px;
    display: flex;
    justify-content: space-between;
    .header_left {
      width: 873px;
      height: 100%;
      padding: 47px 12px 0px;
      box-sizing: border-box;
      background: #ffffff;
      display: flex;
      position: relative;
      .item {
        width: 200px;
        height: calc(100% - 4px);
        margin-right: 16px;
        .img {
          width: 100%;
          height: 200px;
          margin-bottom: 20px;
        }
      }
      .small_house {
        position: absolute;
        top: 18px;
        left: 12px;
        font-size: 18px;
        font-weight: 500;
        line-height: 1;
        width: 850px;
      }
    }
    .header_right {
      width: 305px;
      height: 100%;
      .item {
        width: 100%;
        height: calc((100% - 12px) / 2);
        background: #ffffff;
        margin-bottom: 12px;
        cursor: pointer;
        position: relative;
        .title {
          font-size: 18px;
          font-weight: 500;
          position: absolute;
          top: 18px;
          left: 18px;
          z-index: 2;
        }
        .all {
          font-size: 12px;
          color: #7d7d7d;
          width: 40px;
          height: 16px;
          border: 1px solid #7d7d7d;
          border-radius: 5px;
          text-align: center;
          line-height: 16px;
          position: absolute;
          z-index: 2;
          top: 46px;
          left: 18px;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .duobi {
    padding-top: 40px;
    .tab {
      line-height: 14px;
      display: flex;
      align-self: flex-end;
      .item {
        font-size: 14px;
        color: #3e3e3e;
        font-weight: 400;
        padding: 0 20px;
        margin-right: 40px;
        position: relative;
        cursor: pointer;
        &::after {
          content: "";
          width: 32px;
          height: 1px;
          background: #ff0000;
          position: absolute;
          bottom: -8px;
          left: 50%;
          margin-left: -16px;
          display: none;
        }
        &:hover {
          color: @themeColor;
          &::after {
            background: @themeColor;
          }
        }
      }
      .active {
        color: #ff0000;
        &::after {
          display: block;
        }
      }
    }
    .content {
      display: flex;
    }
  }
  .hotsale {
    padding-top: 26px;
    margin-bottom: 30px;
    .content {
      display: flex;
      .item {
        width: calc((100% - 92px) / 3);
        height: 426px;
        margin-right: 46px;
        background: #ffffff;
        line-height: 1;
        .img {
          width: 366px;
          height: 243px;
          margin-bottom: 18px;
        }
        .title {
          padding: 0 12px;
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          margin-bottom: 12px;
        }
        .sub_title {
          padding: 0 12px;
          font-size: 14px;
          margin-bottom: 16px;
        }
        .other_list {
          display: flex;
          padding: 0 18px;
          .list_item {
            width: calc((100% - 36px) / 3);
            text-align: center;
            margin-right: 18px;
            position: relative;
            .img {
              width: 98px;
              height: 65px;
              margin-bottom: 8px;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .style_item {
    padding: 26px 0 40px 0;
    background: url("~@/assets/img/home_bc.jpg") repeat-x;
    background-size: 100% 100%;
    .theme1 {
      .brand_box {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100px;
        text-align: center;
        color: #ffffff;
        font-size: 18px;
        font-family: PingFang;
        font-weight: 500;
        .brand_name {
          font-size: 34px;
          font-weight: 800;
          line-height: 56px;
        }
        p {
          position: relative;
          z-index: 2;
        }
        &::after {
          display: block;
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 100px;
          background: #313131;
          opacity: 0.6;
        }
      }
    }
    .theme2 {
      margin-top: 10px;
      .title {
        line-height: 34px;
        font-weight: 500;
        color: #100c07;
        font-size: 16px;
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .come_title {
    font-size: 24px;
    font-weight: 800;
    color: #333333;
    line-height: 24px;
    margin-bottom: 24px;
  }
  .more_link {
    display: flex;
    justify-content: space-between;
    span,
    a {
      display: block;
      &:last-child {
        font-size: 14px;
        color: #909399;
        font-weight: 400;
      }
    }
  }
  .mask {
    position: relative;
    cursor: pointer;
    line-height: 1;
    &::after {
      display: block;
      content: "";
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.2;
      position: absolute;
      top: 0;
      left: 0;
      display: none;
    }
    &:hover {
      &::after {
        display: block;
      }
    }
  }
  .goods_item {
    width: calc((100% - 90px) / 4);
    height: 370px;
    background: #ffffff;
    text-align: center;
    margin-right: 30px;
    line-height: 1;
    .img {
      width: 275px;
      height: 275px;
      margin-bottom: 26px;
    }
    .goods_name {
      font-size: 12px;
      padding: 0 12px;
      height: 12px;
      box-sizing: border-box;
      font-weight: 500;
      margin-bottom: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #333333;
    }
  }
  .goods_item:last-child {
    margin-right: 0 !important;
  }
  .price {
    color: #ff0000;
    font-weight: bold;
    font-size: 14px;
  }
  .img_box {
    width: 100%;
    height: 100%;
  }
}
</style>
